





























import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import env from '@/env';

@Component({})
export default class LoginView extends Vue {
  showDialog = true;

  pwd = '';

  username = '';

  usernameError = '';

  passwordError = '';

  submit(event?: Event) {
    if (event) event.preventDefault();
    axios
      .post(
        `${env.backend_url}/login`,
        {
          username: this.username,
          password: this.pwd
        },
        { withCredentials: true }
      )
      .then(({ data: user }) => {
        this.$store.commit('setUser', user);
        this.$root.$i18n.locale = user.language.key;
        this.usernameError = '';
        this.passwordError = '';
        this.$emit('close');
        if (this.$route.path === '/login') this.$router.push({ path: '/' });
      })
      .catch(() => {
        this.usernameError = 'Falscher Username ';
        this.passwordError = 'oder falsches Passwort';
      });
  }

  async created() {
    const { data: user } = await axios.post(
      `${env.backend_url}/restore`,
      {},
      { withCredentials: true }
    );
    if (user === 'invalid session') {
      return;
    }
    this.$store.commit('setUser', user);
    console.log({ user });

    this.$root.$i18n.locale = user.language.key;
  }
}
